<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        <kendo-fileselect
            class="w-full rounded-sm"
            [ngClass]="generateInputStyle()"
            [id]="id"
            [title]="title | translate"
            [restrictions]="restrictions"
            [showFileList]="showFileList"
            [multiple]="isMultiple"
            [disabled]="isDisabled"
            [required]="isRequired"
            [(ngModel)]="value"
            (select)="onFileSelected($event)"
            (focusin)="onFocusIn()"
            (focusout)="onFocusOut()">
            <kendo-fileselect-messages
                [select]="isMultiple ? ('Select files...' | translate) : ('Select file...' | translate)"
                [dropFilesHere]="'Drop files here' | translate" />
        </kendo-fileselect>
    } @else {
        <div class="w-full truncate pt-1.5 pb-1">
            <span kendoTooltip [title]="value()">
                {{ value() }}
            </span>
        </div>
    }
</app-input-label>
